<template>
  <v-container class="pa-0">
      <v-data-table
      dense
        :headers="headers"
        :items="list"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        hide-default-footer
        min="-1"
        max="15"
        @page-count="pageCount = parseInt($event, 10)"
        >
        <template v-slot:item="props">
        <tr>
            <td class="text-left pa-2">{{ props.item.dt_emissao | formatDate }}</td>
            <td class="text-left pa-2">{{ props.item.numero }}</td>
            <td class="text-right pa-2">{{ props.item.valor | formatPrice }}</td>
            <td class="text-center pa-2">
                <v-btn small color="primary lighten-2" icon>
                  <v-switch
                    inset
                    v-model="props.item.is_associado"
                    :value="props.item.is_associado = props.item.is_associado == 1 ?true :false"
                    :input-value="props.item.is_associado = props.item.is_associado == 1 ?true :false"
                  ></v-switch>
                </v-btn>
            </td>
        </tr>
        </template>
    </v-data-table>
    <v-col class="text-center pt-2 pb-0" cols="12">
      <v-pagination class="no-box-shadow" v-model="page" :length="pageCount"></v-pagination>
    </v-col>
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
export default {
    data() {
      return {
        headers: [
            { text: "Data", value: "data", sortable: false },
            { text: "Número", align: "start", value: "numero", sortable: false },
            { text: "Valor (R$)", value: "valor", sortable: false },
            { text: "Associado", value: "associada", sortable: false },
        ],
        select: [],
        page: 1,
        pageCount: 0,
        itemsPerPage: 4,
      }
    },
    filters: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      formatDate(date) {
        return moment(date).format("L");
      },
    },
    props: {
      list: Array,
    }
};
</script>

<style>
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
</style>